import { render, staticRenderFns } from "./PublicCompany.vue?vue&type=template&id=bdbce3a2&"
import script from "./PublicCompany.vue?vue&type=script&lang=js&"
export * from "./PublicCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports